import { empApi } from "./client";

// Đăng nhập nhân viên qua endpoint web riêng (không chặn isAdmin, không device guard)
export const loginWebApi = (phone, password) =>
  empApi.post("/employee/web/login", { phone, password });

// Lấy thông tin nhân viên hiện tại
export const getMeApi = () => empApi.get("/employee/app/getMe");

// Mã giới thiệu (affiliate) của nhân viên hiện tại -> { affiliateCode }
export const getMyAffiliateCodeApi = () =>
  empApi.get("/employee/app/affiliateCode");
